import { render, staticRenderFns } from "./BidCheckout.vue?vue&type=template&id=016a07b5&scoped=true"
import script from "./BidCheckout.vue?vue&type=script&lang=js"
export * from "./BidCheckout.vue?vue&type=script&lang=js"
import style0 from "./BidCheckout.vue?vue&type=style&index=0&id=016a07b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a07b5",
  null
  
)

export default component.exports